/**
 * Creates a promise with exposed functions to resolve or reject it, as well as an exposed status
 */
export function delayedPromise() {
    let status = { s: 'pending' };
    let resolveFn;
    let rejectFn;
    const p = new Promise((ok, ko) => {
        resolveFn = (v) => {
            status = { s: 'resolved', v };
            ok(v);
        };
        rejectFn = (e) => {
            status = { s: 'rejected', e };
            ko(e);
        };
        if (status.s === 'resolved')
            ok(status.v);
        if (status.s === 'rejected')
            ko(status.e);
    });
    return Object.defineProperty(Object.assign(p, {
        resolve: (v) => {
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (resolveFn)
                resolveFn(v);
            else
                status = { s: 'resolved', v };
        },
        reject: (e) => {
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (rejectFn)
                rejectFn(e);
            else
                status = { s: 'rejected', e };
        },
    }), 'status', { enumerable: true, get: () => status });
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVsYXllZFByb21pc2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvZGVsYXllZFByb21pc2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFDSCxNQUFNLFVBQVUsY0FBYztJQWlCN0IsSUFBSSxNQUFNLEdBR3FCLEVBQUUsQ0FBQyxFQUFFLFNBQVMsRUFBRSxDQUFBO0lBQy9DLElBQUksU0FBeUIsQ0FBQTtJQUM3QixJQUFJLFFBQTBCLENBQUE7SUFDOUIsTUFBTSxDQUFDLEdBQUcsSUFBSSxPQUFPLENBQUksQ0FBQyxFQUFFLEVBQUUsRUFBRSxFQUFFLEVBQUU7UUFDbkMsU0FBUyxHQUFHLENBQUMsQ0FBSSxFQUFFLEVBQUU7WUFDcEIsTUFBTSxHQUFHLEVBQUUsQ0FBQyxFQUFFLFVBQVUsRUFBRSxDQUFDLEVBQUUsQ0FBQTtZQUM3QixFQUFFLENBQUMsQ0FBQyxDQUFDLENBQUE7UUFDTixDQUFDLENBQUE7UUFDRCxRQUFRLEdBQUcsQ0FBQyxDQUFNLEVBQUUsRUFBRTtZQUNyQixNQUFNLEdBQUcsRUFBRSxDQUFDLEVBQUUsVUFBVSxFQUFFLENBQUMsRUFBRSxDQUFBO1lBQzdCLEVBQUUsQ0FBQyxDQUFDLENBQUMsQ0FBQTtRQUNOLENBQUMsQ0FBQTtRQUNELElBQUksTUFBTSxDQUFDLENBQUMsS0FBSyxVQUFVO1lBQUUsRUFBRSxDQUFDLE1BQU0sQ0FBQyxDQUFDLENBQUMsQ0FBQTtRQUN6QyxJQUFJLE1BQU0sQ0FBQyxDQUFDLEtBQUssVUFBVTtZQUFFLEVBQUUsQ0FBQyxNQUFNLENBQUMsQ0FBQyxDQUFDLENBQUE7SUFDMUMsQ0FBQyxDQUFDLENBQUE7SUFDRixPQUFPLE1BQU0sQ0FBQyxjQUFjLENBQzNCLE1BQU0sQ0FBQyxNQUFNLENBQUMsQ0FBQyxFQUFFO1FBQ2hCLE9BQU8sRUFBRSxDQUFDLENBQUksRUFBRSxFQUFFO1lBQ2pCLHVFQUF1RTtZQUN2RSxJQUFJLFNBQVM7Z0JBQUUsU0FBUyxDQUFDLENBQUMsQ0FBQyxDQUFBOztnQkFDdEIsTUFBTSxHQUFHLEVBQUUsQ0FBQyxFQUFFLFVBQVUsRUFBRSxDQUFDLEVBQUUsQ0FBQTtRQUNuQyxDQUFDO1FBQ0QsTUFBTSxFQUFFLENBQUMsQ0FBTSxFQUFFLEVBQUU7WUFDbEIsdUVBQXVFO1lBQ3ZFLElBQUksUUFBUTtnQkFBRSxRQUFRLENBQUMsQ0FBQyxDQUFDLENBQUE7O2dCQUNwQixNQUFNLEdBQUcsRUFBRSxDQUFDLEVBQUUsVUFBVSxFQUFFLENBQUMsRUFBRSxDQUFBO1FBQ25DLENBQUM7S0FDRCxDQUFDLEVBQ0YsUUFBUSxFQUNSLEVBQUUsVUFBVSxFQUFFLElBQUksRUFBRSxHQUFHLEVBQUUsR0FBRyxFQUFFLENBQUMsTUFBTSxFQUFFLENBQ0MsQ0FBQTtBQUMxQyxDQUFDIn0=